import { Component, OnInit } from '@angular/core';
import { AreaFocus } from '../../../models';
import { Router, NavigationEnd } from '@angular/router';
import { PworkflowComponent } from '../index';
import { ServiceInterface } from 'services/service.interface';
import { GoogleAnalyticsEventsService } from 'services/google.analytics.events.service';
import { IMajor, IBucket } from 'app/interfaces';

declare var $: any;
@Component({
  selector: 'personal',
  templateUrl: 'personal.component.html'
})

export class PersonalComponent implements OnInit {
  //states: any[] = stateConstant;
  formClass: string = "";
  errormsg: any[] = new Array();
  errdisplay: boolean = false;
  majors: IMajor[];
  bucketlist: IBucket[];
  secondaryBucketList: IBucket[];
  secBucket: any;
  trackingName = "Personal";
  loading: boolean = false;

  constructor(private _services: ServiceInterface,public _parent: PworkflowComponent, private router: Router, public googleAnalyticsEventsService: GoogleAnalyticsEventsService) { }

  async ngOnInit() {
    if(this._parent.campaignName){
      this.trackingName = this._parent.campaignName+" - Personal";
    }
    
    //this.majors = await this._services.getList('/majorslevel');
    this.bucketlist = await this._services.getList('/primary/bucketlist');
    this.loading = true;
    var elmnt = document.getElementById("top");
    elmnt.scrollIntoView();
  }
  
  clickSubmit(valid) {
    this.errormsg = [];
    if(this._parent.model.primary_bucket.length < 1){
      $(".pbucket").addClass('errorclass');
      valid = false;
    }
    if (valid) {
      this.personalsubmit();
    } else {
      if (this._parent.model.primary_bucket.length < 1) {
        this.errdisplay = true;
        this.errormsg.push("Please select area of study.");
      }
      this.formClass = "validate";
    }
  }

  personalsubmit() {
    this._parent.model.bucket_text = this._parent.model.primary_bucket.map(a => a.name).join(',');
    this._parent.model.bucket_id = this._parent.model.primary_bucket.map(a => a.id).join(',');
    //this.googleAnalyticsEventsService.emitEvent(this.trackingName, this.trackingName, this.trackingName, 2);
    this._parent.index++;
  }

  prevAction() {
    this._parent.index--;
    //this.router.navigate(['/']);
  }

  primarySelected(id,title){
    this._parent.model.secondary_bucket = [];
    this._parent.model.secondary_bucket_ids = "";
    if(this._parent.model.primary_bucket.length > 0){
      let primaryCount = this._parent.model.primary_bucket.length;
      let index = this._parent.model.primary_bucket.findIndex(x=>x.id == id);
      if(index > -1){
        this._parent.model.primary_bucket.splice(index, 1);
      }else{
        if(primaryCount < 3){
          let csitem = new AreaFocus();
          csitem.name = title;
          csitem.id = id;
          this._parent.model.primary_bucket.push(csitem);
        }else{
          alert("You cannot select more than 3 Area Of Study")
        }
      }
    }else{
      $(".pbucket").removeClass('errorclass');
      let csitem = new AreaFocus();
      csitem.name = title;
      csitem.id = id;
      this._parent.model.primary_bucket.push(csitem);
    }
  }

  getSelectedBucket(id){
    if(this._parent.model.primary_bucket.length > 0){
      let index = this._parent.model.primary_bucket.findIndex(x => x.id == id);
      if(index > -1){
          return true;
      }else{
          return false;
      }
    }else{
        return false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/personal/personal.component.ts